var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    [
      _c("b-card", { staticClass: "multi-card" }, [
        _c(
          "div",
          { attrs: { slot: "header" }, slot: "header" },
          [
            _c(
              "b-row",
              [
                _c("b-col", { attrs: { md: "8" } }, [
                  _c("h5", [_vm._v(_vm._s(_vm.$t("CONFIGURED.PROCESS_TYPE")))])
                ]),
                _vm._v(" "),
                _c("b-col", { attrs: { md: "4" } }, [
                  _c(
                    "div",
                    { staticClass: "float-right add-field-btn" },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            size: "sm",
                            variant: "secondary",
                            disabled: _vm.unsubscribedCategories.length === 1
                          },
                          on: { click: _vm.handleSubscribeModal }
                        },
                        [
                          _c("i", { staticClass: "fa fa-plus" }),
                          _c("span", [
                            _vm._v(
                              " " + _vm._s(_vm.$t("COMMON.SUBSCRIBE")) + " "
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ])
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "timeline-div" }, [
          _c("ul", { staticClass: "timeline timeline-horizontal" }, [
            _c(
              "div",
              { staticClass: "flex-container" },
              _vm._l(_vm.accountCategories, function(category, index) {
                return _c(
                  "li",
                  { key: category, staticClass: "timeline-item" },
                  [
                    _c("div", { staticClass: "timeline-badge bg-primary" }, [
                      _c("strong", [_vm._v(_vm._s(index + 1))])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "timeline-panel role-panel" },
                      [
                        _c("p", [_vm._v(_vm._s(_vm._f("titlize")(category)))]),
                        _vm._v(" "),
                        _c(
                          "b-dropdown",
                          {
                            staticClass: "panel-option",
                            attrs: { "no-caret": "" }
                          },
                          [
                            _c("template", { slot: "button-content" }, [
                              _c("div", [
                                _c("i", { staticClass: "fa fa-ellipsis-v" })
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-dropdown-item",
                              {
                                on: {
                                  click: function($event) {
                                    _vm.handleUnsubscribeModal(category)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("COMMON.UNSUBSCRIBE")))]
                            )
                          ],
                          2
                        )
                      ],
                      1
                    )
                  ]
                )
              })
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "subscribeModal",
          attrs: {
            "hide-header-close": "",
            centered: "",
            title: _vm.$t("CONFIGURED.SUBSCRIBE_MODAL"),
            "ok-title": _vm.$t("COMMON.SUBSCRIBE"),
            "cancel-title": _vm.$t("COMMON.CANCEL"),
            "ok-variant": "secondary",
            "cancel-variant": "light"
          },
          on: { ok: _vm.subscribeNewCategory, hidden: _vm.hideSubscribeModal }
        },
        [
          _c(
            "b-card",
            { staticClass: "mb-0" },
            [
              _c(
                "b-row",
                { staticClass: "form-group" },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-form-select", {
                        staticClass: "form-control",
                        attrs: {
                          plain: true,
                          options: _vm.unsubscribedCategories
                        },
                        model: {
                          value: _vm.selectedCategory,
                          callback: function($$v) {
                            _vm.selectedCategory = $$v
                          },
                          expression: "selectedCategory"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "unsubscribeModal",
          attrs: {
            "hide-header-close": "",
            centered: "",
            title: _vm.$t("CONFIGURED.UNSUBSCRIBE_MODAL"),
            "ok-title": _vm.$t("COMMON.UNSUBSCRIBE"),
            "cancel-title": _vm.$t("COMMON.CANCEL"),
            "ok-variant": "secondary",
            "cancel-variant": "light"
          },
          on: { ok: _vm.unsubscribeCategory, hidden: _vm.hideUnSubscribeModal }
        },
        [
          _c(
            "b-card",
            { staticClass: "mb-0" },
            [
              _c(
                "b-row",
                { staticClass: "form-group" },
                [
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _c("p", [
                      _vm._v("Are you sure want unscubscribe '"),
                      _c("strong", [
                        _vm._v(
                          _vm._s(_vm._f("capitalize")(_vm.selectedCategory))
                        )
                      ]),
                      _vm._v("' ?")
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "This will no longer be available for processing documents."
                      )
                    ])
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7b37a026", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b37a026","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/processType.vue
// module id = 1343
// module chunks = 2